module.exports = __webpack_public_path__ + "img/advantage4.1aef4c6f.png";